<ion-app>
	<ion-router-outlet></ion-router-outlet>
	<!-- <lib-bfsg-accessibility [isMobile]="true"></lib-bfsg-accessibility> -->
</ion-app>
